// @unocss-include
import Layout from '@/components/layout/sider-menu-layout/index.vue';
import type { SiteRouteItem } from '@/router/types';
import { PermissionPageKey } from '@/types/permission';

// 售后质量（全新并行模块，与现有「售后」应用互不影响）。
// 一期：客诉源数据模块（录入/导入导出/管理）。二期看板、三期问题管理后续追加子路由。
const route: SiteRouteItem = {
  path: '/after-sale-quality',
  component: Layout,
  name: PermissionPageKey.AfterSaleQuality,
  meta: {
    title: '售后质量管理',
    icon: 'carbon:sales-ops',
    iconCls: 'bg-teal-500',
    // Q12：一期暂全开放，后续按角色限制入口显示
  },
  redirect: '/after-sale-quality/dashboard',
  children: [
    {
      path: 'dashboard',
      name: PermissionPageKey.AfterSaleQualityDashboard,
      component: () => import('../pages/dashboard/index.vue'),
      meta: { title: '客诉看板', icon: 'material-symbols:dashboard' },
    },
    {
      path: 'source-data',
      name: PermissionPageKey.AfterSaleQualitySourceData,
      component: () => import('../pages/source-data/index.vue'),
      meta: { title: '客诉源数据', icon: 'material-symbols:table' },
    },
    {
      path: 'base-number',
      name: PermissionPageKey.AfterSaleQualityBaseNumber,
      component: () => import('../pages/base-number/index.vue'),
      meta: { title: '激活数录入', icon: 'material-symbols:edit-square-outline' },
    },
    {
      path: 'issue',
      name: PermissionPageKey.AfterSaleQualityIssue,
      component: () => import('../pages/issue/index.vue'),
      meta: { title: '问题管理', icon: 'material-symbols:assignment-outline' },
    },
    {
      path: 'issue/detail/:id',
      name: PermissionPageKey.AfterSaleQualityIssueDetail,
      component: () => import('../pages/issue/detail.vue'),
      meta: { title: '问题详情', hideInMenu: true },
    },
  ],
};

export default route;
